import { render, staticRenderFns } from "./BtnExportar.vue?vue&type=template&id=615469eb&"
import script from "./BtnExportar.vue?vue&type=script&lang=js&"
export * from "./BtnExportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports